module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-body"
  }, [_c('div', {
    staticClass: "c-body__title"
  }, [_c('h2', [_c('span', [_vm._v("DataURI")]), _vm._v(" "), _c('button', {
    class: {
      '-active': _vm.showHelp
    },
    on: {
      "click": _vm.toggleHelp
    }
  }, [_c('c-icon', {
    attrs: {
      "name": 'question-circle'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "c-help"
  }, [_c('div', {
    staticClass: "c-help__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "e-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.disableLimit),
      expression: "options.disableLimit"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.disableLimit) ? _vm._i(_vm.options.disableLimit, null) > -1 : (_vm.options.disableLimit)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.options.disableLimit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.options.disableLimit = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.options.disableLimit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.options.disableLimit = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("サイズ制限を解除する")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-body__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('div', {
    staticClass: "c-datauri-droparea",
    on: {
      "drop": _vm.onDrop
    }
  }, [_c('div', {
    staticClass: "c-datauri-droparea__text"
  }, [_vm._v("\n\t\t\t\t\tこのエリアにファイルをドロップするか、データをペーストしてください\n\t\t\t\t")])])]), _vm._v(" "), _c('hr', {
    staticClass: "e-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "e-section"
  }, [_c('div', {
    staticClass: "c-datauri-result"
  }, [_c('ul', {
    staticClass: "c-datauri-result__list"
  }, [_c('transition-group', {
    attrs: {
      "name": "slide-in"
    }
  }, _vm._l((_vm.results), function(r, index) {
    return _c('li', {
      key: r.key,
      staticClass: "c-datauri-result__item"
    }, [_c('div', {
      staticClass: "c-datauri-result__preview",
      style: (r.style)
    }, [(r.text) ? _c('div', {
      staticClass: "c-datauri-result__preview-text"
    }, [_vm._v(_vm._s(r.text))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "c-datauri-result__content"
    }, [_c('button', {
      staticClass: "c-datauri-result__button-remove",
      on: {
        "click": function($event) {
          _vm.remove(r.key)
        }
      }
    }, [_c('c-icon', {
      attrs: {
        "name": 'cross'
      }
    })], 1), _vm._v(" "), _c('dl', {
      staticClass: "c-datauri-result__props"
    }, [_c('dt', [_vm._v("type")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(r.type))]), _vm._v(" "), _c('dt', [_vm._v("size")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("formatNumber")(r.size)))])]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (r.data),
        expression: "r.data"
      }],
      staticClass: "e-input-text -full -invert",
      attrs: {
        "readonly": ""
      },
      domProps: {
        "value": (r.data)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          r.data = $event.target.value
        }
      }
    })])])
  }))], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n\t\t\t\t\tペーストされたデータや、ドロップされたファイルからDataURIを生成します。"), _c('br'), _vm._v("\n\t\t\t\t\tサイズ上限は2MBです。（上限はオプションで制限解除できます）\n\t\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b00b348","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/page/datauri.vue
// module id = 66
// module chunks = 0